import { stats } from "../data";

export default function StatsBar() {
  return (
    <section aria-label="赛事数据速览" className="bg-primary-500 text-background-50">
      <div className="w-full px-4 md:px-8 py-8 md:py-10">
        <dl className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((item) => (
            <div key={item.label} className="flex flex-col">
              <dt className="order-2 mt-1.5 text-xs md:text-sm text-primary-100">{item.label}</dt>
              <dd className="order-1 font-heading text-2xl md:text-4xl font-black">{item.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}